import React, { CSSProperties, FC } from 'react';
import { Button, Space } from 'antd';
import { Formik } from 'formik';
import { Form, Input, SubmitButton } from 'formik-antd';
import { FormikOnSubmit } from 'lib/formik.utils';
import { SearchOutlined } from '@ant-design/icons/lib';
import styled from 'styled-components';
import { useFormatMessage } from 'common/hooks/useFormatMessage';
import { FormattedMessage } from 'react-intl';
import { SubpartnersFilterSelect } from 'common/components/SubpartnersSelect';
import { ModeSelect } from 'common/components/ModeSelect';
import { DeviceStatusSelect } from 'common/components/StatusSelect';

const StyledSpace = styled(Space)`
  flex-wrap: wrap;
  > * {
    margin-bottom: 0.5rem;
    flex-grow: 1;
    flex-shrink: 1;
  }
`;

const StyledForm = styled(Form)`
  max-width: 100%;
`;

export interface ProfileOwnerFiltersFormModel {
  deviceStatus?: string;
  serialNumber?: string;
  assignedDevice?: boolean;
  modeType?: 'FAMILY_MODE' | 'PRO_MODE' | 'both';
  status?: string;
  hasToken?: boolean;
  partnerName?: string;
  partnerID?: number | undefined;
}

export interface ProfileOwnerFiltersProps {
  loading?: boolean;
  value?: ProfileOwnerFiltersFormModel;
  onSubmit: FormikOnSubmit<ProfileOwnerFiltersFormModel>;
  style?: CSSProperties;
  shouldHidePartnerColumn: boolean;
}

export const BusinessPartnersDevicesFilters: FC<ProfileOwnerFiltersProps> = ({
  onSubmit,
  loading,
  value = {},
  style,
  shouldHidePartnerColumn,
}) => {
  const intlMessage = useFormatMessage();

  return (
    <Formik initialValues={value} onSubmit={onSubmit} onReset={onSubmit}>
      <StyledForm style={style} layout="inline">
        <StyledSpace>
          <Input
            name="serialNumber"
            placeholder={intlMessage({ id: 'deviceSerialNumber' })}
            style={{ minWidth: 150 }}
          />
          <Input
            name="boxSerialNumber"
            placeholder={intlMessage({ id: 'devices.boxSerialNumber' })}
            style={{ minWidth: 150 }}
          />
          {!shouldHidePartnerColumn && (
            <SubpartnersFilterSelect
              name="partnerID"
              placeholder={intlMessage({ id: 'partner' })}
              style={{ minWidth: 180, width: '100%' }}
            />
          )}
          <ModeSelect
            name="modeType"
            placeholder={intlMessage({ id: 'devices.mode' })}
            style={{ minWidth: 150 }}
          />
          <DeviceStatusSelect
            name="deviceStatus"
            placeholder={intlMessage({ id: 'status' })}
            style={{ minWidth: 240, width: '100%' }}
          />
          <Space>
            <SubmitButton
              type="default"
              loading={loading}
              icon={<SearchOutlined />}
            >
              <FormattedMessage id="search" tagName="span" />
            </SubmitButton>
            <Button id="button-clear-devices-filter" htmlType="reset">
              <FormattedMessage id="clear" />
            </Button>
          </Space>
        </StyledSpace>
      </StyledForm>
    </Formik>
  );
};
